export const ROOMS_FETCH = 'CHAT/ROOMS/FETCH'
export const ROOMS_FETCH_STARTED = 'CHAT/ROOMS/FETCH_STARTED'
export const ROOMS_FETCH_SUCCESS = 'CHAT/ROOMS/FETCH_SUCCESS'
export const ROOMS_FETCH_FAILED = 'CHAT/ROOMS/FETCH_FAILED'

export const ROOMS_CREATE = 'CHAT/ROOMS/CREATE'
export const ROOMS_CREATE_STARTED = 'CHAT/ROOMS/CREATE_STARTED'
export const ROOMS_CREATE_SUCCESS = 'CHAT/ROOMS/CREATE_SUCCESS'
export const ROOMS_CREATE_FAILED = 'CHAT/ROOMS/CREATE_FAILED'

export const ROOMS_BYID_FETCH = 'CHAT/ROOMS/BYID/FETCH'
export const ROOMS_BYID_FETCH_STARTED = 'CHAT/ROOMS/BYID/FETCH_STARTED'
export const ROOMS_BYID_FETCH_SUCCESS = 'CHAT/ROOMS/BYID/FETCH_SUCCESS'
export const ROOMS_BYID_FETCH_FAILED = 'CHAT/ROOMS/BYID/FETCH_FAILED'

export const ROOMS_REALTIME_LOAD_UNREAD = 'CHAT/ROOMS/REALTIME/LOAD_UNREAD'
export const ROOMS_REALTIME_SYNC_UNREAD = 'CHAT/ROOMS/REALTIME/SYNC_UNREAD'

export const ROOMS_UPDATED = 'CHAT/ROOMS/UPDATED'
export const ROOM_OPTIMISTIC_UPDATED = 'CHAT/ROOM/OPTIMISTIC_UPDATED'
